// extracted by mini-css-extract-plugin
export default {"contents":"rE-z","sectionHeading":"sE-z"};